// extracted by mini-css-extract-plugin
export default {"whyChoose":"WhyChoose_whyChoose__hTriJ","content":"WhyChoose_content__P7aTs","title":"WhyChoose_title__ClwTj","subtitle":"WhyChoose_subtitle__glCgb","btn":"WhyChoose_btn__-xqjV"};